// Posted by HubSpot's chat iframe for every agent message the visitor has not
// seen, unlike unreadConversationCountChanged which fires once per thread.
const HUBSPOT_NEW_MESSAGE_TYPE = "show-page-title-notification";

export const SUPPORT_REPLY_TOAST_COOLDOWN_MS = 5000;

export function isHubspotNewMessageNotification(data: unknown): boolean {
  if (typeof data !== "string") return false;

  try {
    const message: unknown = JSON.parse(data);
    return (
      typeof message === "object" &&
      message !== null &&
      "type" in message &&
      message.type === HUBSPOT_NEW_MESSAGE_TYPE
    );
  } catch {
    return false;
  }
}

type SupportReplyAnnouncementInput = {
  isWidgetOpen: boolean;
  lastAnnouncedAt: number | null;
  now: number;
};

export function shouldAnnounceSupportReply({
  isWidgetOpen,
  lastAnnouncedAt,
  now,
}: SupportReplyAnnouncementInput): boolean {
  if (isWidgetOpen) return false;
  if (lastAnnouncedAt === null) return true;
  return now - lastAnnouncedAt >= SUPPORT_REPLY_TOAST_COOLDOWN_MS;
}
